module.exports = __webpack_public_path__ + "fonts/2a2dde09241ead00c97795553ee8b056.txt";